export default __webpack_public_path__ + "static/media/cipm.715f6fd0.png";